import styled from "styled-components";

interface IAuthModalLoginTemplateContainerProps {
  hasImage: boolean;
}

export const AuthModalLoginTemplateContainer = styled.div<IAuthModalLoginTemplateContainerProps>`
  position: relative;

  align-items: center;
  display: flex;
  flex-direction: column;

  height: 100%;
  width: 100%;
  max-width: 360px;

  margin: 0 auto;

  .loader {
    width: 1rem;
    height: 1rem;
  }

  #auth-modal-login-alert {
    max-width: 100%;
    text-wrap: pretty;
    height: auto;
    margin-bottom: 1rem;
  }

  animation: appearFromLeft 0.4s;

  @keyframes appearFromLeft {
    from {
      opacity: 0;
      transform: translateX(-5px);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;

export const AuthModalLoginTemplateFallback = styled.div`
  display: grid;
  place-items: center;

  height: 440px;

  transition: all 0.3s;
`;
